
import {Questionary} from "../../model/questionary";
import TMapPointSetting, {TMapPoint} from "./point/TMapPointSetting";

export default class GroupFilter {
    // list of allowed groups
    private haystack: string[] = [];

    constructor(
        private readonly questionary: Questionary,
        private readonly setting: TMapPointSetting,
    ) {
        this.refreshHaystack();
    }

    /**
     * Create or update allowed groups list
     */
    public refreshHaystack(): void {
        this.haystack = [];
        if (this.setting.brandFilter) {
            for (const f of this.setting.brandFilter) {
                const cellItem = this.questionary.formsById[f.formId]?.grid?.cellById[f.cellId]?.cellItems[0];
                if (Boolean(cellItem?.getVariable())) {
                    this.haystack = this.haystack.concat(f.filterValues);
                }
            }
        }

        if (this.setting.quotaFilter) {
            for (const q of this.setting.quotaFilter) {
                if (this.isQuotaCellFull(q.quota, q.cell)) {
                    this.haystack = this.haystack.filter(b => q.filterValues.indexOf(b) === -1);
                }
            }
        }

    }

    private isQuotaCellFull(quotaName: string, cellName: string): boolean {
        return this.questionary.quotas?.isCellFull(quotaName, cellName, this.questionary.state) || false;
    }

    /**
     * Decide if filter settings allows the point
     * @param point
     */
    public filter(point: TMapPoint): boolean {
         if (!this.setting.brandFilter?.length) { // without filter, allow all
             return true;
         }

         if (point.group === undefined) {
             return false;
         }

         return this.haystack.indexOf(point.group) !== -1;
    }
}
